// extracted by mini-css-extract-plugin
export default {"modalActions":"QRModal_modalActions__r7RjW","container":"QRModal_container__kFl-Y","title":"QRModal_title__bNFbe","qrSection":"QRModal_qrSection__UJMTL"};